import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {Observable} from 'rxjs/Observable';

import {SessionService} from './session.service';
import {environment} from '../../../environments/environment';

@Injectable()
export class BaseHttpService {

  constructor(protected httpClient: HttpClient, protected sessionService: SessionService) {
  }

  httpGet(apiUrl: String, responseType: any = 'json', observe: any = 'body'): Observable<Object> {
    return this.httpClient.get(this.buildUrl(apiUrl), {
      headers: this.buildAuthorizationHeader(),
      responseType: responseType,
      observe: observe
    });
  }

  httpPost(apiUrl: String, model: any) {
    return this.httpClient.post(this.buildUrl(apiUrl), model, {
      headers: this.buildAuthorizationHeader()
    });
  }

  httpPut(apiUrl: String, model: any, secured = true) {
    let options = {};
    if (secured) {
      options = {
        headers: this.buildAuthorizationHeader()
      };
    }
    return this.httpClient.put(this.buildUrl(apiUrl), model, options);
  }

  httpDelete(apiUrl) {
    return this.httpClient.delete(this.buildUrl(apiUrl), {
      headers: this.buildAuthorizationHeader(),
      responseType: 'text'
    });
  }

  httpDeleteWithBody(apiUrl: string, model: any) {
    const options = {
      headers: this.buildAuthorizationHeader(),
      body: model
    };

    return this.httpClient.request('delete', this.buildUrl(apiUrl), options);
  }

  protected buildUrl(apiUrl) {
    return environment.baseApiUrl + apiUrl;
  }

  private buildAuthorizationHeader() {
    return new HttpHeaders()
      .set('Content-type', 'application/json;charset=UTF-8')
      .set('Authorization', 'Bearer ' + this.sessionService.getAccessToken());
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/base.service.ts